function detectMob() {
  const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

if (detectMob()) {
  $("#form-desktop .option-color").remove();
  $("#form-desktop .variant-input-wrap").remove();
}

$(".product-form__cart-submit").click(function (e) {
  if ($("#size-selected").text().includes("Selecciona")) {
    e.preventDefault();
    alert("Selecciona talla");
  }
});

$(".dot-size").click(function () {
  $(".size-options").slideUp("fast");
  $("#size-out").hide();
  $("#size-selected").text($(this).text());
  let size = $(this).text();
  let color = $(".select-color").val();
  let variant = color + " / " + size;
  $(".select-talla option").each(function () {
    $(this).attr("selected", false);
  });
  $(`.select-talla option[value="${size}"]`).attr("selected", true);
  $(".product-single__variants option").each(function () {
    if ($(this).text().trim().includes(variant)) {
      var price = $(this).attr("data-price");
      var price_compareat = $(this).attr("data-compareat");
      if (price_compareat.length > 1) {
        $(".price-regular").html(price_compareat);
        $(".compare-price").html(price);
        if (!$(".compare-price").hasClass("on-sale")) $(".compare-price").addClass("on-sale");
        if (!$(".price-regular").hasClass("product__price--compare")) {
          $(".price-regular").addClass("product__price--compare");
        }
      } else {
        $(".price-regular").html(price);
        $(".price-regular").removeClass("product__price--compare");
        $(".compare-price").html("");
      }
      if ($(this).attr("data-soldout").includes("soldout")) {
        $(".product-form__cart-submit").attr("disabled", true);
        $(".product-form__cart-submit").text("SOLD OUT");
        $(".product-form__cart-submit").addClass("btn-soldout");
      } else {
        $(".product-form__cart-submit").attr("disabled", false);
        $(".product-form__cart-submit").text("ADD TO CART");
        if ($(".product-form__cart-submit").hasClass("btn-soldout")) {
          $(".product-form__cart-submit").removeClass("btn-soldout");
        }
      }
      $(this).attr("selected", true);
    } else {
      $(this).attr("selected", false);
    }
  });
});

function fix_price_mobile() {
  var item = $(".product-single__variants :selected");
  var price = item.attr("data-price");
  console.log("price: " + price);
  var price_compareat = item.attr("data-compareat");
  console.log("price_compare: " + price_compareat);
  if (price_compareat.length > 1) {
    $(".price-regular").html(price_compareat);
    $(".compare-price").html(price);
    if (!$(".compare-price").hasClass("on-sale")) $(".compare-price").addClass("on-sale");
    if (!$(".price-regular").hasClass("product__price--compare")) {
      $(".price-regular").addClass("product__price--compare");
    }
  } else {
    $(".price-regular").html(price);
    $(".price-regular").removeClass("product__price--compare");
    $(".compare-price").html("");
  }
}

fix_price_mobile();

$(".color-dot-product").click(function () {
  $(".color-dot-product").each(function () {
    $(this).css("border", "none");
  });
  $(this).css("border", "1px solid black");

  let option = $(this).attr("data-option");
  let size = $(".select-talla").val();
  let variant = "";
  if ($(".dot-size").length > 0) {
    variant = option + " / " + size;
  } else {
    variant = option;
  }
  let colorimages = "color-" + $(this).attr("data-images");
  $(".select-color option").each(function () {
    $(this).attr("selected", false);
  });
  $(`.select-color option[value="${option}"]`).attr("selected", true);

  $(".product-single__variants option").each(function () {
    if ($(this).text().trim().includes(variant)) {
      var price = $(this).attr("data-price");
      var price_compareat = $(this).attr("data-compareat");
      if (price_compareat.length > 1) {
        $(".price-regular").html(price_compareat);
        $(".compare-price").html(price);
        if (!$(".compare-price").hasClass("on-sale")) $(".compare-price").addClass("on-sale");
        if (!$(".price-regular").hasClass("product__price--compare")) {
          $(".price-regular").addClass("product__price--compare");
        }
      } else {
        $(".price-regular").html(price);
        $(".price-regular").removeClass("product__price--compare");
        $(".compare-price").html("");
      }
      if ($(this).attr("data-soldout").includes("soldout")) {
        $(".product-form__cart-submit").attr("disabled", true);
        $(".product-form__cart-submit").text("SOLD OUT");
        $(".product-form__cart-submit").addClass("btn-soldout");
      } else {
        $(".product-form__cart-submit").attr("disabled", false);
        $(".product-form__cart-submit").text("ADD TO CART");
        if ($(".product-form__cart-submit").hasClass("btn-soldout")) {
          $(".product-form__cart-submit").removeClass("btn-soldout");
        }
      }
      $(this).attr("selected", true);
    } else {
      $(this).attr("selected", false);
    }
  });

  $("#color-images-total").hide();
  $(".color-images").each(function () {
    if ($(this).attr("data-color") == colorimages) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });

  swiper_update();
});

$(".size-selector").click(function () {
  if ($(".size-options").css("display") == "none") {
    $(".size-options").slideDown("fast");
    $("#size-out").show();
  } else {
    $(".size-options").slideUp("fast");
  }
});

$("#size-out").click(function () {
  $(this).hide();
  $(".size-options").slideUp("fast");
});

$("#naiz").click(function () {
  $(".size-options").slideUp("fast");
  $("#size-out").hide();
  $("#naiz-sizeform-opener").trigger("click");
});

$(window).scroll(function () {
  if (document.URL.includes("/products/")) {
    if (scrollY > 450) {
      $(".site-header-sticky").css("background", "black");
    } else {
      $(".site-header-sticky").css("background", "inherit");
    }
  }
});

$(".colors-dot").click(function (e) {
  e.preventDefault();
  var element_color = document.getElementById("colors-title");
  element_color.scrollIntoView({block: "center", behavior: "smooth"});
});

$(".site-nav__menu-toggle").click(function (e) {
  e.preventDefault();
  window.history.back();
});

$(window).scroll(function () {
  if (scrollY > 710 && window.innerWidth < 580) {
    $("#submit-mobile").addClass("floating-btn");
    $('.whatsapp-float').css("bottom","8.5em")
  } else {
    $("#submit-mobile").removeClass("floating-btn");
    $('.whatsapp-float').css("bottom","2.5em")
  }
});
